/**
 * Ad Blocker: Stands AdBlocker
 *
 * The only one of the six blockers in the top 100 that is uniquely identifiable, and
 * it's identifiable because it labels its own work. Where AdBlock and Adblock Plus
 * apply cosmetic filtering invisibly (see docs/undetectable/adblock.md), Stands injects
 * numbered stylesheets with a vendor-prefixed id and leaves a global behind.
 *
 * Observed on version 2.1.68: 13 <style id="stndz-general-N"> elements and
 * window.blockPopupsFunc.
 */
import { probeSelector, probeGlobal } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'lgblnfidahcdcjddiepkckcfdhpknnjh';
export const standsAdblocker: ExtensionDefinition = {
  id: ID,
  name: 'Ad Blocker: Stands AdBlocker',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3_000_000,
  notes:
    'Unlike the eyeo blockers, Stands names its injected stylesheets, which makes it ' +
    'the one blocker here that can be told apart from its competitors.',
  signals: [
    { id: 'dom-stndz-stylesheets', kind: 'dom',
      description: 'Look for <style id="stndz-general-*"> — the vendor-prefixed cosmetic filtering sheets.',
      weight: 1, run: () => probeSelector('style[id^="stndz-"]', { timeoutMs: 1500 }) },
    { id: 'global-block-popups', kind: 'global',
      description: 'Check for window.blockPopupsFunc, left in the main world by its popup blocker.',
      weight: 1, run: () => probeGlobal('blockPopupsFunc') },
  ],
};
